// mantine
import { Button, Loader } from '@mantine/core';
// icons
import { Plus } from 'lucide-react';
// components
import { PopoverButton } from '@newo/ui-kit';
import { useQueryClient } from '@tanstack/react-query';
import WebhookItem from '@/pages/Integrations/components/Webhooks/components/WebhookItem';
import WebhookForm from '@/pages/Integrations/components/Webhooks/components/WebhookForm';
// utils
import { useWebhooksQuery } from '@/services/webhooks/webhooks.queries.ts';
import NoRecords from '@/components/NoRecords';

interface WebhooksProps {
    connectorIdn: string;
}

const Webhooks = ({ connectorIdn }: WebhooksProps) => {
    const queryClient = useQueryClient();

    const { data = [], isLoading, isSuccess } = useWebhooksQuery();
    const webhooks = data.filter((w) => w.connector_idn === connectorIdn);

    const handleUpdate = () => {
        queryClient.invalidateQueries({
            queryKey: ['webhooks']
        });
    };

    return (
        <div className="flex flex-col gap-4">
            <div>
                <PopoverButton
                    trigger={
                        <Button
                            component="div"
                            leftSection={<Plus />}
                            variant="transparent"
                        >
                            Add Webhook
                        </Button>
                    }
                >
                    {(close) => (
                        <WebhookForm
                            connectorIdn={connectorIdn}
                            onClose={close}
                            onSubmit={handleUpdate}
                        />
                    )}
                </PopoverButton>
            </div>

            {isLoading ? <Loader className="mx-auto my-20" /> : undefined}
            {isSuccess && webhooks.length === 0 ? (
                <NoRecords>No webhooks found</NoRecords>
            ) : undefined}

            {webhooks.map((webhook) => (
                <WebhookItem
                    key={webhook.id}
                    webhook={webhook}
                    onDelete={handleUpdate}
                    onUpdate={handleUpdate}
                />
            ))}
        </div>
    );
};

export default Webhooks;
